import styled from "styled-components";
import { Div } from "components";

export const Wrapper = styled(Div)`
  width: 100%;
  flex-direction: row;
  display: flex;
  padding: 24px 0;

  @media(max-width: 920px){
    flex-wrap: wrap;
    margin-left: 0 !important;
    justify-content: center;
    padding: 0;
  }
`;

export const ImageWrapper = styled(Div)`
  display: flex;
  @media(max-width: 920px){
    width: 100%;
    padding: 10px 0px;
    justify-content: center;
    background-color: ${({theme}) => theme.colors[theme.background.sextenary.color][[theme.background.sextenary.intensity]]};
  }
`